<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="reportingLogActivityType in reportingLogActivityTypes">
                    <td>
                        <input type="text" v-if="reportingLogActivityType.editable" class="form-control" :name="reportingLogActivityType.value" v-model="form['value'][reportingLogActivityType.id]">
                        <span v-if="!reportingLogActivityType.editable">{{ reportingLogActivityType.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeActivityType(reportingLogActivityType)" class="btn btn-danger" v-if="reportingLogActivityType.deleteable" :title="uLang('app.delete_reporting_log_activity_type')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newActivityType" :placeholder="uLang('app.create_entity', { entity: lang('app.reporting_log_activity_type')})" :title="uLang('app.add_new_reporting_log_activity_type')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addActivityType" :disabled="form.busy">{{ uLang('app.create_entity', { entity: lang('app.reporting_log_activity_type')}) }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'ActivityTypes',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newActivityType: '',
                reportingLogActivityTypes: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.entity_updated', { entity: lang('app.reporting_log_activity_types')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.reportingLogActivityTypes = data;

                data.forEach(function (reportingLogActivityType){
                    if(reportingLogActivityType.editable){
                        this.value[reportingLogActivityType.id] = reportingLogActivityType.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addActivityType() {
                if (this.newActivityType === '')
                    return;

                this.reportingLogActivityTypes.push(
                    {
                        id: this.newActivityType,
                        value: this.newActivityType,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newActivityType] = this.newActivityType;
                this.newActivityType = '';
            },

            removeActivityType(reportingLogActivityType) {
                new DestroyAlert({
                    text: this.lang('app.delete_warning_entity', { entity: this.lang('app.reporting_log_activity_type') })
                }).show().then(async () => {
                    delete this.form.value[reportingLogActivityType.id];

                    //remove the reportingLogActivityType from the table
                    this.reportingLogActivityTypes = this.reportingLogActivityTypes.filter(function (current_reporting_log_activity_type) {
                        return current_reporting_log_activity_type.value != reportingLogActivityType.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>
